import {
  getProductColumns,
  getDiscountColumns,
} from '@/components/product/common/girdColumns/ProductCommonGridColumns';
import { ProductsSearchPostRequest } from 'ncp-api-supporter';
import { i18n } from '@/main';
import { headerWithTooptipRenderer } from '@/utils/grid/rendererUtils';
import { OptionData } from '@/helpers/type';
import { MARKETING_TYPE } from '@/const/contents/product';

export const SINGLE_ITEM_SELECT_LENGTH = 1;
export const THREE_MONTH = 3;

export const requestParam: ProductsSearchPostRequest = {
  data: {
    mallNos: [] as number[],
    keywordInfo: {
      type: 'PRODUCT_NAME',
      keywords: [''],
    },
    marketingChannels: ['NAVER_SHOPPING'],
    page: 1,
    size: 30,
    periodInfo: {
      type: 'REGISTER_DATE',
      period: {
        startYmdt: '',
        endYmdt: '',
      },
    },
    applyStatusType: 'ALL',
    deliverable: 'ALL',
    deliveryFeeType: 'ALL',
    allowsShippingTogether: 'ALL',
    allowsFrontDisplay: 'ALL',
    platformType: 'ALL',
    saleMethodType: 'ALL',
    brandNo: null,
    adminNo: null,
    partnerNo: null,
    allowsPromotion: null,
    canApplyCoupon: null,
    canApplyAdditionalDiscount: null,
    hasAdditionalDiscount: null,
    commission: {
      type: null,
    },
    shippingAreaType: null,
    onlyParentProduct: null,
    customPropertyValueNos: null,
  },
};

export const searchKeywordOptions = [
  { name: 'MARKETING.CONFIGURATION.PRODUCT_NAME', value: 'PRODUCT_NAME' },
  { name: 'MARKETING.CONFIGURATION.MALL_PRODUCT_NO', value: 'MALL_PRODUCT_NO' },
];

export const datePickerOptions: OptionData<string>[] = [
  {
    value: 'REGISTER_DATE',
    name: 'PRODUCT.SEARCH.REGISTER_DATE',
  },
  {
    value: 'PRODUCT_MODIFIED_DATE',
    name: 'PRODUCT.SEARCH.MODIFIED_DATE',
  },
  {
    value: 'SALE_START_DATE',
    name: 'PRODUCT.SEARCH.SALE_START_DATE',
  },
  {
    value: 'SALE_END_DATE',
    name: 'PRODUCT.SEARCH.SALE_END_DATE',
  },
  {
    value: 'PRE_SALE_START_DATE',
    name: 'PRODUCT.SEARCH.PRE_SALE_START_DATE',
  },
  {
    value: 'PRE_SALE_END_DATE',
    name: 'PRODUCT.SEARCH.PRE_SALE_END_DATE',
  },
];

export const gridProps = () => ({
  header: {
    columns: [
      {
        name: 'displayable',
        renderer: props => {
          props.tooltipId = 'displayable';
          return headerWithTooptipRenderer(props);
        },
      },
      {
        name: 'available',
        renderer: props => {
          props.tooltipId = 'availableAds';
          return headerWithTooptipRenderer(props);
        },
      },
    ],
  },
  columns: [
    ...getProductColumns(),
    ...getDiscountColumns(),
    {
      header: 'MARKETING.CONFIGURATION.DISPLAYABLE',
      name: 'displayable',
      align: 'center',
      formatter: ({ row }) => {
        if (!row.marketingSettings || !row.marketingSettings[0]?.displayable) {
          return i18n.t('MARKETING.CONFIGURATION.NO_DISPLAYABLE');
        }
        return i18n.t('MARKETING.CONFIGURATION.YES_DISPLAYABLE');
      },
    },
    {
      header: 'MARKETING.CONFIGURATION.AVAILABLE_ADS',
      name: 'available',
      align: 'center',
      formatter: ({ row }) =>
        //NOTE: EP가 없었을때, 운영중이던 상품에 대해서 연동상태 Y로 표기 하기 위해 null , emptyArray도 Y로 표기
        !row.marketingSettings?.length ||
        row.marketingSettings?.find(({ channelType }) => channelType === MARKETING_TYPE.NAVER_SHOPPING)?.available
          ? 'Y'
          : 'N',
    },
    {
      header: 'MARKETING.CONFIGURATION.ADDITIONAL_INFO',
      name: 'additionalInfo',
      align: 'center',
      formatter: () =>
        `<button type="button" style="height: 25px; line-height: normal" class='double_click_allow type-white'>
        ${i18n.t('MODIFY').toString()}
        </button>`,
    },
  ],
  options: {
    rowHeaders: ['checkbox'],
    pageOptions: {
      page: 1,
      perPage: 30,
      totalCount: 0,
    },
  },
  displayOptions: {
    hasExcelDownloadButton: false,
    hasSettingButton: false,
    pageSizeKey: 'size',
    headerTooltipOption: [
      {
        id: '#displayable',
        popupData: { data: { message: i18n.t('MARKETING.CONFIGURATION.DISPLAYABLE_TOOLTIP'), leftAlign: true } },
      },
      {
        id: '#availableAds',
        popupData: { data: { message: i18n.t('MARKETING.NAVER_SHOPPING.AVAILABLE_ADS_TOOLTIP'), leftAlign: true } },
      },
    ],
  },
});
